import type { Dimension, FilterField, SortState } from './clientPricingHistoryTypes';

export const CURRENCY_NATIVE = 'Native';
export const CURRENCY_USD = 'USD';

export const CURRENCY_OPTIONS = [
  { value: CURRENCY_NATIVE, label: 'Native' },
  { value: CURRENCY_USD, label: 'USD' },
];

// In the server's order, which is also the grid's column order. Year is always part of the rows.
export const DIMENSIONS: Dimension[] = [
  { key: 'Client', label: 'Client' },
  { key: 'Industry', label: 'Industry' },
  { key: 'ServiceType', label: 'Service Type' },
  { key: 'FieldworkOffice', label: 'Fieldwork Office' },
  { key: 'Country', label: 'Country' },
];

// The rows open split by client.
export const DEFAULT_SPLIT_BY = ['Client'];

export const DEFAULT_SORT: SortState = { key: null, desc: false };

// The measures sort largest first on the first click.
export const MEASURE_SORT_KEYS = ['InvoicedEvaluations', 'ClientFee', 'FeePerEvaluation'];

export const FILTER_FIELDS: FilterField[] = [
  { key: 'Industries', optionsKey: 'industries', label: 'Industry' },
  { key: 'ServiceTypes', optionsKey: 'serviceTypes', label: 'Service Type' },
  { key: 'FieldworkOffices', optionsKey: 'fieldworkOffices', label: 'Fieldwork Office' },
  { key: 'Countries', optionsKey: 'countries', label: 'Country' },
];

// The category the Filters panel keeps this tab's saved filters under.
export const SEARCH_SAVE_TYPE = 'ClientPricingHistory';
